import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapRightMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTRightMenu');
});
var bootStrapRightMenu = function (props) {
    console.log('======Hi i am right menu displaying menuList======', props);
    return (React.createElement(BootStrapRightMenu, __assign({}, props), props.children));
};
export var RightMenu = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapRightMenu(props);
            break;
        default:
            componentToDisplay = bootStrapRightMenu(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
RightMenu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=RightMenu.js.map